module.exports = __webpack_public_path__ + "static/img/beian_photo.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beian_photo.png
// module id = 9GtA
// module chunks = 36